import { render, staticRenderFns } from "./PostThemeAndSentiment.vue?vue&type=template&id=0b4eb028&scoped=true&"
import script from "./PostThemeAndSentiment.vue?vue&type=script&lang=js&"
export * from "./PostThemeAndSentiment.vue?vue&type=script&lang=js&"
import style0 from "./PostThemeAndSentiment.vue?vue&type=style&index=0&id=0b4eb028&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4eb028",
  null
  
)

export default component.exports